import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import { Card, Typography, Chip } from '@otp/ui';
import { MarkerActive } from '@otp/icons';
import { formatDate } from '@otp/utils';
import { StoreModel } from 'src/graphql/generated/graphql';

export const RestaurantInfo = ({ store }: { store: Partial<StoreModel> }) => {
  const { t } = useTranslation();

  if (!store) {
    return null;
  }

  const infoItems = [
    {
      label: t('common.organization'),
      value: store.organization?.name,
    },
    {
      label: t('manage-restaurants.state-site-id'),
      value: <Chip label={store.stateSiteId} color="primary" />,
    },
    {
      label: t('manage-restaurants.glin'),
      value: store.globalLocationId,
    },
    {
      label: t('manage-restaurants.current-time'),
      value: formatDate(new Date(), 'M/d/yyyy h:mm:ss a (zzz)', {
        timeZone: store.timezoneAbbreviation as string | undefined,
      }),
    },
  ];

  return (
    <div>
      <Typography
        variant="body2"
        fontWeight="bold"
        component="div"
        className="flex items-center"
      >
        <MarkerActive className="mr-2" /> {t('common.general')}
      </Typography>

      <Card className="w-full mt-4">
        {infoItems.map((info, i) => (
          <div
            className={clsx('flex justify-between', { 'mt-3': !!i })}
            key={info.label}
          >
            <Typography variant="subtitle1">{info.label}</Typography>
            <Typography variant="subtitle1" fontWeight="bold">
              {info.value}
            </Typography>
          </div>
        ))}
      </Card>
    </div>
  );
};
